export default __webpack_public_path__ + "static/media/CPC.d75f5c8d.svg";